import React, { useCallback } from 'react';
import { useLocation } from 'wouter';
import { Link } from 'wouter';

import useMicromagStory from '../../hooks/useMicromagStory';

import { MicromagItem } from '../../types/micromag';
import Micromag from '../partials/Micromag';
import PageMeta from '../partials/PageMeta';

import styles from '../../styles/pages/micromag.module.css';

interface MicromagPageProps {
    micromag?: MicromagItem | null;
    micromags?: MicromagItem[] | null;
    screen?: string | null;
    hasHome?: boolean;
}

function MicromagPage({
    micromag = null,
    micromags = null,
    screen = null,
    hasHome = true,
}: MicromagPageProps) {
    const [, setLocation] = useLocation();
    const { slug = null } = micromag || {};
    const { story = null, loading = false } = useMicromagStory(micromag);

    const { title = null, metadata = null } = story || {};
    const { shareImage } = metadata || {};
    const { url: shareImageUrl = null } = shareImage || {};

    const { components: screens = [] } = story || {};
    const baseUrl = slug !== null && hasHome ? `/${slug}` : '';

    const pathScreenId = screen || null;
    const pathScreenIndex =
        pathScreenId !== null && pathScreenId.match(/^[0-9]+$/) !== null
            ? parseInt(pathScreenId, 10) - 1
            : null;
    const screenByPathId =
        pathScreenId !== null
            ? screens.find(({ id: screenId = null }) => screenId === pathScreenId) || null
            : null;
    const screenByPathIndex = pathScreenIndex !== null ? screens[pathScreenIndex] || null : null;
    const currentScreen =
        screenByPathId ||
        screenByPathIndex ||
        (pathScreenId === '' ? screens[0] : null) ||
        screens[0] ||
        null;

    const onScreenChange = useCallback(
        (newScreen = null) => {
            const { id: newScreenId = null } = newScreen || {};
            const newScreenIndex =
                screens.findIndex(({ id: screenId = null }) => screenId === newScreenId) || null;
            setLocation(
                newScreenIndex !== null ? `${baseUrl}/${newScreenIndex + 1}` : `${baseUrl}/1`,
            );
        },
        [screens, setLocation],
    );

    return (
        <div className={styles.container}>
            <PageMeta
                title={`${title} | Extraordinaires, les postiers de l'année`}
                image={shareImageUrl}
            />
            <Micromag
                micromag={story}
                basePath={baseUrl}
                hasHome={hasHome}
                currentScreenId={currentScreen !== null ? currentScreen.id : null}
                className={styles.micromag}
                onScreenChange={onScreenChange}
                micromags={micromags}
            />
            {pathScreenIndex === 4 ? (
                <div className={styles.footer}>
                    <Link className={styles.cta} href="/">
                        Retrouvez toutes les histoires&nbsp;des
                        <br />
                        <strong>postiers de l'année 2025</strong>
                    </Link>
                </div>
            ) : null}
        </div>
    );
}

export default MicromagPage;
